import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import ThemeCard from "../../components/ThemeCard";
import ThemeDatePicker from "../../components/ThemeDatePicker";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Modal,
  Popconfirm,
  Row,
  Tooltip,
  notification,
} from "antd";
import ThemeDropDown from "../../components/ThemeDropDown";
import ThemeCardTable from "../../components/ThemeCardTable";
import { useDispatch, useSelector } from "react-redux";
import { setSummaryDataFilter } from "../../store/slice/globleSlice";
import ActionButton from "../../components/ActionButton";
import ThemeInput from "../../components/ThemeInput";
import { formatToINR } from "../../components/FormateToINR/formatToINR";
import { valanBillDate } from "../../components/CommanFuction/CommanFunction";
import { StyledButton } from "../../styles/commonStyle";
import { DeleteIcon, EditIcon } from "../Dashboard/style";
import { PdfDiv, buttonTitles } from "../SummaryReport/style";
import { FilePdfOutlined } from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";
import { useCalculateLedger, useGetLedger } from "../../APICall/apiHooks";
import { BillMarketOptions, EntryTypeOption } from "../../Helper/constant";

const UserLedger = () => {
  const userId = useParams()?.id;
  const isSelf = userId === "self";

  // state
  const [value, setValue] = useState({
    entryAfter: "",
    billType: "",
    entryType: "",
  });
  const [showModal, setShowModal] = useState({ flag: false, record: null });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const indexRef = useRef(0);
  const updateRef = useRef({});

  //redux
  const loginUser = useSelector((state) => state.authSlice?.userDetail);
  const loginUserId = loginUser?.userId;

  //custom hook for ledger recalculate
  const { ledgerMutate, ledgerCalculateLoading } = useCalculateLedger({
    id: userId === "self" ? loginUserId : userId,
  });

  //custom hook for get user's ledger data
  const { ledgerData, ledgerLoading, refetchLeger } = useGetLedger({
    userId: userId === "self" ? loginUserId : userId,
    value,
  });

  const queryClient = useQueryClient();

  //redux
  const isAuthorize = useSelector(
    (state) => state?.authSlice?.additionalSharing?.ledgerDelete
  );
  const isOwner = useSelector(
    (state) => state.authSlice?.userDetail?.accountType === "owner"
  );

  const handleSubmit = () => {
    refetchLeger();
  };

  const deleteLedger = async (id) => {
    let payload = {};
    payload.updateBalance = updateRef.current?.[id] || false;
    try {
      let response = await APICall(
        "delete",
        `${EndPoints.updateLedger}delete-ledger?ledgerId=${id}&recalculateLedgerBalance=false`,
        payload
      );
      if (response.status === 200) {
        notification.success({ message: response?.data?.message });
        queryClient.refetchQueries({ queryKey: ["userLedger"] });
        updateRef.current = {};
      } else {
        notification.error({ message: response?.data?.message });
      }
    } catch (error) {
      notification.error({ message: error?.message });
    }
  };

  //function
  const handleDate = (date, string, name) => {
    setValue((pre) => ({ ...pre, [name]: date }));
  };

  const onChangeDropdown = (name, value, option) => {
    setValue((pre) => ({ ...pre, [name]: value?.[0] ? value[0] : value }));
  };

  const handleEdit = (record) => {
    setShowModal({ flag: true, record: record });
  };

  const handleCancel = () => {
    setShowModal({ flag: false, record: null });
  };

  const handleClear = async () => {
    setValue({
      entryAfter: "",
      billType: "",
      entryType: "",
    });

    // wait for complete render and set value to null and then after refetch ledger
    await new Promise((resolve) => setTimeout(resolve, 0));
    refetchLeger();
  };

  const handleDescription = (record) => {
    return (
      <div>
        <p>Are you sure to delete this ledger?</p>
        <Checkbox
          onClick={(e) => {
            updateRef.current = {
              ...updateRef.current,
              [record?._id]: e.target.checked,
            };
          }}
        >
          Update Ledger Balance
        </Checkbox>
      </div>
    );
  };
  //updateBalance
  // column
  const columns = [
    {
      title: "Sr No.",
      dataIndex: "date",
      key: "date",
      width: "5rem",
      align: "center",
      render: (text, record, index) => {
        return <span>{index + 1}</span>;
      },
    },
    {
      title: "CLIENT INFO",
      dataIndex: "client",
      key: "client",
      width: "15rem",
      align: "left",
      render: (text, record) => {
        return (
          <div style={{ textAlign: "left" }}>
            {`${record?.userId} (${record?.accountName})`}
          </div>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: "10rem",
      align: "left",
      render: (text, record) => {
        const finalDate = valanBillDate(record?.date, true);
        return <span>{finalDate}</span>;
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      align: "left",
      width: "7rem",
    },
    {
      title: "Debit",
      dataIndex: "debit",
      key: "debit",
      align: "center",
      width: "10rem",
      render: (text, record) => {
        if (record?.entryType === "debit") {
          return (
            <div style={{ color: "red" }}>{formatToINR(record?.amount)}</div>
          );
        } else {
          return "-";
        }
      },
    },
    {
      title: "Credit",
      dataIndex: "credit",
      key: "credit",
      align: "center",
      width: "10rem",
      render: (text, record) => {
        if (record?.entryType === "credit") {
          return (
            <div style={{ color: "green" }}>{formatToINR(record?.amount)}</div>
          );
        } else {
          return "-";
        }
      },
    },
    {
      title: "Balance",
      dataIndex: "ledgerBalance",
      key: "ledgerBalance",
      align: "center",
      width: "10rem",
      render: (text, record) => {
        const ledgerBalance = record?.ledgerBalance;
        return (
          <div style={{ color: ledgerBalance < 0 ? "red" : "green" }}>
            {formatToINR(ledgerBalance)}
          </div>
        );
      },
    },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
      align: "left",
      width: "15rem",
      render: (text, record) => {
        return (
          <div>
            <span>{record?.systemRemark}</span>
            {record?.systemRemark && record?.remark && (
              <Divider type="vertical" style={{ borderColor: "black" }} />
            )}
            <span>{record?.remark}</span>
          </div>
        );
      },
    },
    {
      title: "Bill",
      dataIndex: "bill",
      key: "bill",
      align: "center",
      width: "7rem",
      render: (text, record) => {
        const showPDF =
          record?.type === "valanBill" || record?.type === "valanPoint";
        const showEditDelete =
          record?.type === "point" || record?.type === "JV" || isOwner;
        return (
          <Row justify={"space-evenly"}>
            <PdfDiv>
              {showPDF ? (
                <FilePdfOutlined
                  onClick={() => {
                    navigate(`/valanBill/${record?.userId}`);
                    dispatch(
                      setSummaryDataFilter({
                        withoutBrokerage: false,
                        valan: record?.valanId,
                      })
                    );
                  }}
                />
              ) : (
                "-"
              )}
            </PdfDiv>
            {isAuthorize && showEditDelete && !isSelf && (
              <EditIcon onClick={() => handleEdit(record)} />
            )}
            {isAuthorize && showEditDelete && !isSelf && (
              <Popconfirm
                title="delete the ledger"
                description={() => handleDescription(record)}
                onConfirm={() => deleteLedger(record?._id)}
                placement="topRight"
                okText="Yes"
                cancelText="No"
              >
                <DeleteIcon />
              </Popconfirm>
            )}
          </Row>
        );
      },
    },
  ];

  return (
    <>
      <ThemeCard>
        <Row gutter={[20, 20]} justify="left" align="bottom">
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <ThemeDatePicker
              title="Entry After"
              name="entryAfter"
              placeholder="Select"
              onChange={(date, string) =>
                handleDate(date, string, "entryAfter")
              }
              width={"100%"}
              value={value?.entryAfter}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <ThemeDropDown
              title="Bill Type"
              name="billType"
              placeholder="Select"
              width={"100%"}
              options={EntryTypeOption}
              $onChange={onChangeDropdown}
              value={value.billType}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <ThemeDropDown
              title="Entry Type"
              name="entryType"
              placeholder="Select"
              width={"100%"}
              options={BillMarketOptions}
              $onChange={onChangeDropdown}
              value={value?.entryType}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <p>
              <span>{`Ledger Balance: `}</span>
              <span
                style={{
                  color: ledgerData?.ledgerBalance >= 0 ? "green" : "red",
                }}
              >
                {ledgerData?.ledgerBalance || 0}
              </span>
            </p>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={5}
            lg={{
              offset: 1,
              span: 3,
            }}
            xl={{
              offset: 2,
              span: 3,
            }}
          >
            <StyledButton type="primary" onClick={handleSubmit}>
              Find
            </StyledButton>
          </Col>
          <Col xs={24} sm={12} md={5} lg={3} xl={3}>
            <StyledButton type="primary" onClick={handleClear}>
              Clear Search
            </StyledButton>
          </Col>
        </Row>
      </ThemeCard>

      <ThemeCardTable
        buttonType={true}
        buttonTitle={buttonTitles}
        data={ledgerLoading ? [] : ledgerData?.entries}
        column={columns}
        headingStyle={false}
        isFilterTrue={true}
        isLoading={ledgerLoading}
        filtertype={"ledger"}
      />

      <Row align={"end"} gutter={[10, 10]} style={{ marginTop: "0.5rem" }}>
        {isOwner && (
          <Col>
            <Tooltip title="Re-Calculate All Ledger">
              <Popconfirm
                title="Re-Calculate All Ledger"
                description="Are you sure to re-calculate all users ledger?"
                onConfirm={() => {
                  indexRef.current = 1;
                  ledgerMutate("all");
                }}
                placement="top"
              >
                <Button
                  type="primary"
                  loading={ledgerCalculateLoading && indexRef.current == 1}
                >
                  Re-Ledger ALL
                </Button>
              </Popconfirm>
            </Tooltip>
          </Col>
        )}
        <Col>
          <Tooltip title="Re-Calculate Ledger">
            <Popconfirm
              title="Re-Calculate Ledger"
              description="Are you sure to re-calculate ledger?"
              onConfirm={() => {
                indexRef.current = 0;
                ledgerMutate();
              }}
              placement="topLeft"
            >
              <Button
                type="primary"
                loading={ledgerCalculateLoading && indexRef.current == 0}
              >
                Re-Ledger
              </Button>
            </Popconfirm>
          </Tooltip>
        </Col>
      </Row>

      {showModal.flag && (
        <EditLedger handleCancel={handleCancel} record={showModal?.record} />
      )}
    </>
  );
};

export default UserLedger;

export const EditLedger = ({ handleCancel, record }) => {
  const queryClient = useQueryClient();
  // state
  const [data, setData] = useState({
    amount: record?.amount,
    remark: record?.remark || null,
  });
  const [loading, setLoading] = useState(false);

  // api call
  const handleSubmit = async () => {
    if (!data?.amount) {
      notification.error({ message: "Please fill amount before submit" });
      return;
    }
    setLoading(true);
    try {
      let response = await APICall(
        "PUT",
        `${EndPoints.updateLedger}edit-ledger/${record?._id}`,
        data
      );
      if (response.status === 200) {
        notification.success({ message: response?.data?.message });
        queryClient.refetchQueries({ queryKey: ["userLedger"] });
        handleCancel();
      } else {
        notification.error({ message: response?.data?.message });
      }
    } catch (error) {
      notification.error({ message: error?.message });
    } finally {
      setLoading(false);
    }
  };

  // function
  const onChangeValue = ({ target: { name, value } }) => {
    setData({ ...data, [name]: value });
  };

  return (
    <Modal
      title={
        <Row justify={"left"}>
          <Col span={12}>{`Edit Amount`}</Col>
          <Col span={10}>{`${record?.accountName} (${record?.userId})`}</Col>
        </Row>
      }
      open={true}
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={false}
    >
      <ThemeCard bordered={false}>
        <Row
          justify={"space-around"}
          gutter={[10, 10]}
          // align={"middle"}
        >
          <Col span={8}>
            <ThemeInput
              marginBottom={"0rem"}
              width={"100%"}
              title="Amount"
              className="ThemeInput"
              extraProps={{
                input_type: "number",
              }}
              inputProps={{
                placeholder: "amount",
                name: "amount",
                value: data?.amount,
                onChange: onChangeValue,
              }}
            />
          </Col>
          <Col span={8}>
            <ThemeInput
              marginBottom={"0rem"}
              width={"100%"}
              title={`${record?.entryType === "credit" ? "Credit" : "Debit"}`}
              extraProps={{
                input_type: "number",
              }}
              inputProps={{
                // placeholder: "LOT",
                name: "lot",
                value: record?.amount,
                // onChange: onChangeValue,
                readOnly: "true",
                // onBlur: onChangeValue,
                // disabled: record?.marketName === "NSE EQU" ? true : false,
              }}
            />
          </Col>
          <Col span={8}>
            <ThemeInput
              marginBottom={"0rem"}
              width={"100%"}
              title="Balance"
              className="ThemeInput"
              extraProps={{
                input_type: "number",
              }}
              inputProps={{
                placeholder: "Balance",
                name: "balance",
                value: record?.ledgerBalance,
                // onChange: onChangeValue,
                // onBlur: onChangeValue,
                // disabled: record?.marketName !== "NSE FUT" ? true : false,
                readOnly: "true",
              }}
            />
          </Col>
        </Row>
        <Row justify={"center"} style={{ marginTop: "1rem" }}>
          <Col span={22}>
            <ThemeInput
              marginBottom={"0rem"}
              width={"100%"}
              title="Remark"
              className="ThemeInput"
              inputProps={{
                placeholder: "Remark",
                name: "remark",
                value: data?.remark,
                onChange: onChangeValue,
              }}
            />
          </Col>
        </Row>
        <Row
          justify={"center"}
          gutter={[20, 20]}
          style={{ marginTop: "2rem", gap: "2rem" }}
        >
          <ActionButton
            title={"Submit"}
            onClick={handleSubmit}
            loading={loading}
          />
          <ActionButton
            title={"Cancel"}
            buttonType="cancel"
            onClick={handleCancel}
          />
        </Row>
      </ThemeCard>
    </Modal>
  );
};
